<template>
  <section class="practice">
    <div class="row">
      <aside class="col-md-3 col-sm-12 cus-sidebar">
        <practiceSidebar />
      </aside>
      <div v-if="isLoading" class="loader">
        <div class="wave-container">
          <div class="wave"></div>
          <div class="wave"></div>
          <div class="wave"></div>
          <div class="wave"></div>
          <div class="wave"></div>
        </div>
        <p>Loading...</p>
      </div>
      <div v-if="!isLoading" id="content" class="dashboard-home col-md-9 col-sm-12 new-dashboard-home">
        <div class="row">
          <!-- begin col-3 -->
          <div class="col-md-8">
            <div v-if="successMessage" class="success-message">{{ successMessage }}</div>
            <!-- begin widget -->
            <div class="material-box bg-white">
              <div class="row content-row form-group">
                <div class="col-md-12 top-title">
                  <h3>Message From Dr. Sawyer:</h3>
                </div>
                <div class="">
                  <template v-if="loginUser.userID == 2">
                    <!-- <div contenteditable="true" class="col-md-12" v-html="message['message']"></div>  -->
                    <div class="editable-content" contenteditable="true" ref="editableDiv" @blur="handleBlur"
                      v-html="message['message']"></div>

                    <!-- <input type="text" class="editable-content" v-model="message['message']"> -->
                  </template>
                  <template v-else>
                    <div class="col-md-12" v-html="message['message']"></div>
                  </template>
                </div>
              </div>
            </div>
            <!-- end widget -->
          </div>
          <!-- end col-3 -->
          <!-- begin col-3 -->
          <div class="col-md-4">
            <div class="material-box bg-white team-box success-rate">
              <div class="row content-row">
                <div class="col-md-12 top-title bd-none">
                  <h3>Our Team</h3>
                </div>
                <div class="col-md-12">
                  <div class="table-responsive mb-0">
                    <table
                      class="table table-bordered over-border-none table-hover table-last-row-no-border-bottom m-b-0">
                      <thead>
                        <tr></tr>
                      </thead>
                      <tbody>
                        <tr v-for="(user, index) in allUsers" :key="index">
                          <td>{{ user.FirstName }} {{ user.LastName }}</td>
                          <td>{{ user.Status }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- end widget -->
            </div>
          </div>
          <!-- end col-3 -->
        </div>
        <!-- begin row -->
        <div class="row shell_total-nopadd">
          <div class="col-md-6 shell_total_graph Bottom_Margin" v-for="(goal, index) in goals" :key="index">
            <div class="material-box bg-white team-box">
              <div class="row content-row">
                <div class="col-md-12 top-title">
                  <h3>{{ goal.title }}</h3>
                </div>
                <div class="col-md-12">
                  <div class="widget-body">
                    <div id="print_me">
                      <div class="col-md-12">
                        <!-- begin panel -->
                        <line-chart :chart-data="goal.chartData" :chart-options="goal.chartOptions"></line-chart>
                        <!-- end panel -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end row -->
      </div>
    </div>
  </section>
</template>

<script>
import practiceSidebar from "./../Practice/components/Sidebar.vue";
import userAPI from "../userApi";
import LineChart from "./components/LineChart.vue";
import moment from "moment";

export default {
  name: "practice_dashboard",
  components: {
    practiceSidebar,
    LineChart,
  },
  data() {
    return {

      successMessage: null,
      allUsers: {},
      message: {
        message: "",
      },
      loginUser: {},
      focuses: {},
      goals: [],
    };
  },
  methods: {
    handleBlur(event) {
      this.message['message'] = event.target.innerHTML;
      userAPI.updateMessage(
        {
          UserID: this.loginUser.userID,
          message: event.target.innerHTML,
        },
        (res) => {
          this.successMessage = res.data.message;
          setTimeout(() => {
            this.successMessage = null;
          }, 3000);
        },
        (err) => {
          console.log(err);
        }
      );
    },
    buildChartOptions(focusName) {
      const isNpPvRev = focusName === "New Patient" || focusName === "Patient Visits" || focusName === "Revenue";
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: !isNpPvRev,
            },
          }],
        },
        tooltips: {
          mode: "index",
          intersect: false,
          callbacks: {
            label: function (tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label || "";
              // hide the invisible spacer dataset from tooltip
              if (!label) return null;
              label += ": ";
              let val = tooltipItem.yLabel;
              if (val === null || val === undefined || isNaN(val)) return label + "0";
              if (focusName === "Revenue") {
                return label + "$" + parseFloat(val).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
              } else if (focusName === "Report of Findings" || focusName === "Care Plan Renewals") {
                return label + parseFloat(val).toFixed(0) + "%";
              } else {
                return label + parseFloat(val).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
              }
            },
          },
        },
        hover: { mode: "index", intersect: false },
      };
    },

    getGraphData() {
      userAPI.getGraphData(
        {
          reportYear: moment().format("Y"),
          PracticeID: this.loginUser.PracticeID,
          UserID: 0,
        },
        (res) => {
          const currentMonth = moment().month(); // 0-based
          const currentYear = parseInt(moment().format("Y"));
          const selectedYear = currentYear; // dashboard always uses current year

          const npCharts = [];
          const pvCharts = [];
          const revCharts = [];
          const rofCprCharts = [];

          res.data.data.forEach((ele) => {
            const focusName = ele.focus.FocusName;
            const isRofOrCpr = focusName === "Report of Findings" || focusName === "Care Plan Renewals";

            if (isRofOrCpr) {
              // ROF / CPR — skip index 0, keep existing logic
              const labels = ele.graph
                .map((g, idx) => idx === 0 ? null : g.m_name)
                .filter((l) => l !== null);

              const goalData = ele.graph
                .map((g, idx) => idx === 0 ? null : g.Target)
                .filter((d) => d !== null);

              const actualData = ele.graph
                .map((g, idx) => {
                  if (idx === 0) return null;
                  const monthIdx = idx - 1;
                  const inRange = selectedYear < currentYear || monthIdx <= currentMonth;
                  return inRange ? (g.avg !== null ? g.avg : 0) : null;
                })
                .filter((d) => d !== null);

              rofCprCharts.push({
                title: focusName,
                chartOptions: this.buildChartOptions(focusName),
                chartData: {
                  labels,
                  datasets: [
                    { label: "Target (%)", data: goalData, borderColor: "#ecb201", borderWidth: 2, fill: false },
                    { label: "Started (%)", data: actualData, borderColor: "#1b17bb", borderWidth: 2, fill: false },
                    { label: "", data: [40, 60, 100], borderColor: "white", borderWidth: 0, fill: false },
                  ],
                },
              });
            } else {
              // NP / PV / REV — index 0 is the "Total" placeholder row, skip it
              // After slice(1): index 0 = Jan, index 1 = Feb, ..., index 11 = Dec
              const graphData = ele.graph.slice(1);

              const labels = graphData.map((g) => g.m_name);

              // --- TOTAL chart ---
              const totalGoalData = graphData.map((g) => g.goal !== "" ? g.goal : 0);

              const totalActualData = graphData.map((g, idx) => {
                const inRange = selectedYear < currentYear || idx <= currentMonth;
                return inRange ? (g.actual !== null ? g.actual : 0) : null;
              });

              const totalChart = {
                title: focusName + " (Total)",
                chartOptions: this.buildChartOptions(focusName),
                chartData: {
                  labels,
                  datasets: [
                    { label: "Goal", data: totalGoalData, borderColor: "#ecb201", borderWidth: 2, fill: false },
                    { label: "Actual", data: totalActualData, borderColor: "#1b17bb", borderWidth: 2, fill: false, spanGaps: false },
                  ],
                },
              };

              // --- MONTHLY chart ---
              // Goal = difference between consecutive cumulative goals
              // Actual = only completed months (idx < currentMonth), null for current & future
              const monthlyGoalData = graphData.map((g, idx) => {
                const prevGoal = idx > 0 ? (graphData[idx - 1].goal !== "" ? graphData[idx - 1].goal : 0) : 0;
                const currGoal = g.goal !== "" ? g.goal : 0;
                return currGoal - prevGoal;
              });

              const monthlyActualData = graphData.map((g, idx) => {
                // Only completed months (strictly before current month)
                const isCompleted = selectedYear < currentYear || idx < currentMonth;
                return isCompleted ? (g.month_actual !== null ? Math.round(g.month_actual) : null) : null;
              });

              const monthlyChart = {
                title: focusName + " (Monthly)",
                chartOptions: this.buildChartOptions(focusName),
                chartData: {
                  labels,
                  datasets: [
                    { label: "Goal", data: monthlyGoalData, borderColor: "#ecb201", borderWidth: 2, fill: false },
                    { label: "Actual", data: monthlyActualData, borderColor: "#1b17bb", borderWidth: 2, fill: false, spanGaps: false },
                  ],
                },
              };

              if (focusName === "New Patient") {
                npCharts.push(totalChart, monthlyChart);
              } else if (focusName === "Patient Visits") {
                pvCharts.push(totalChart, monthlyChart);
              } else {
                revCharts.push(totalChart, monthlyChart);
              }
            }
          });

          // Order: NP Total/Monthly → PV Total/Monthly → ROF → CPR → REV Total/Monthly
          this.goals = [...npCharts, ...pvCharts, ...rofCprCharts, ...revCharts];
        },
        (err) => {
          console.log(err);
        }
      );
    },

    getUsersListByPractice() {
      userAPI.getUsersListByPractice(
        { PracticeID: this.loginUser.PracticeID },
        (res) => {
          this.allUsers = res.data.data;
          this.getGraphData();
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getMessage() {
      userAPI.getMessage(
        (res) => {
          this.message = res.data.data;
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
  mounted() {
    this.loginUser = JSON.parse(localStorage.getItem("userDetails"));
    this.getMessage();

    this.getUsersListByPractice();
  },
  computed: {},
};
</script>

<style>
@media (max-width: 767px) {
  .dr-msg .col-md-12 br:nth-child(1) {
    display: none;
  }
}

.editable-content {
  outline: none;
  padding: 10px;
  min-height: 100px;
}

.success-message {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 15px;
  background: #d1f0ed;
  color: #108078;
  margin-bottom: 5px;
  border-radius: 5px;
}
</style>